import { useCallback, useEffect, useState } from "react";
import { resolveDeliveryPayload } from "../utils/deliveryApi";

// 统一解析交付链接（短链 / 老链接）的加载状态。
// status: "loading" | "ready" | "invalid"（无效/不存在）| "expired"（已过期，服务端拦截）| "error"（网络异常，可重试）
export function useDeliveryPayload(token) {
    const [state, setState] = useState({ status: "loading", payload: null });
    const [reloadKey, setReloadKey] = useState(0);

    const reload = useCallback(() => {
        setReloadKey((key) => key + 1);
    }, []);

    useEffect(() => {
        let cancelled = false;
        setState({ status: "loading", payload: null });
        resolveDeliveryPayload(token)
            .then((payload) => {
                if (cancelled) {
                    return;
                }
                setState(
                    payload
                        ? { status: "ready", payload }
                        : { status: "invalid", payload: null }
                );
            })
            .catch((error) => {
                if (cancelled) {
                    return;
                }
                if (error?.code === "EXPIRED") {
                    setState({
                        status: "expired",
                        payload: { archiveMarkdown: error.archiveMarkdown || "" },
                    });
                } else {
                    setState({ status: "error", payload: null });
                }
            });
        return () => {
            cancelled = true;
        };
    }, [token, reloadKey]);

    return { ...state, reload };
}

export default useDeliveryPayload;
